import React from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
} from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';

const TicketCreate = (props) => {
  return (
    <Create {...props} title="Create lesson" redirect="list">
      <SimpleForm>
        <TextInput source="title" />
        <RichTextInput source="description" />
        <FileInput
          label="Attachment"
          source="attachment"
          multiple={false}
          sx={{
            boxShadow: '0px 0px 6px 4px darkgrey',
            padding: '0px 8px',
            '& span': { fontSize: '1.75em', color: 'darkred' },
          }}
        >
          <FileField source="src" title="title" />
        </FileInput>
      </SimpleForm>
    </Create>
  );
};

export default TicketCreate;
